import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons";
import { Input } from "~/components/ui/input";
import { SelectInput } from "~/components/SelectInput";
import { SelectOption } from "~/components/SelectInput/types";

// // // //

type StatusFilter = "active" | "revoked" | "all";
type SortBy = "name" | "createdAt" | "lastUsedAt";

const STATUS_OPTIONS: Array<SelectOption> = [
    { value: "all", content: { label: "All clients" } },
    { value: "active", content: { label: "Active" } },
    { value: "revoked", content: { label: "Revoked" } },
];

const SORT_OPTIONS: Array<SelectOption> = [
    { value: "createdAt", content: { label: "Newest created" } },
    { value: "name", content: { label: "Name (A–Z)" } },
    { value: "lastUsedAt", content: { label: "Recently used" } },
];

// // // //

/**
 * OauthClientsToolbar
 * Search input plus status/sort filters and the result count for the clients table.
 */
export function OauthClientsToolbar(props: {
    search: string;
    status: StatusFilter;
    sortBy: SortBy;
    resultCount: number;
    onSearchChange: (value: string) => void;
    onStatusChange: (value: StatusFilter) => void;
    onSortByChange: (value: SortBy) => void;
}) {
    const {
        search,
        status,
        sortBy,
        resultCount,
        onSearchChange,
        onStatusChange,
        onSortByChange,
    } = props;

    // // // //

    return (
        <div className="flex flex-col gap-3 border-b p-4 lg:flex-row lg:items-center lg:justify-between">
            <div className="relative w-full lg:max-w-xs">
                <FontAwesomeIcon
                    icon={faMagnifyingGlass}
                    className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground"
                    aria-hidden="true"
                />
                <Input
                    value={search}
                    placeholder="Search by name or client ID…"
                    aria-label="Search OAuth clients"
                    className="h-9 rounded-lg bg-background pl-9"
                    onChange={(event) => onSearchChange(event.target.value)}
                />
            </div>

            <div className="flex items-center gap-2">
                <label className="flex items-center gap-1.5 text-sm">
                    <span className="text-muted-foreground">Status:</span>
                    <SelectInput
                        value={status}
                        onChange={(value) =>
                            onStatusChange(value as StatusFilter)
                        }
                        options={STATUS_OPTIONS}
                        size="sm"
                        className="h-9 w-40 rounded-lg bg-background"
                    />
                </label>
                <label className="flex items-center gap-1.5 text-sm">
                    <span className="text-muted-foreground">Sort:</span>
                    <SelectInput
                        value={sortBy}
                        onChange={(value) => onSortByChange(value as SortBy)}
                        options={SORT_OPTIONS}
                        size="sm"
                        className="h-9 w-48 rounded-lg bg-background"
                    />
                </label>
                <span className="ml-1 hidden text-xs text-muted-foreground sm:inline">
                    {resultCount} {resultCount === 1 ? "result" : "results"}
                </span>
            </div>
        </div>
    );
}
